export default {
    cartTotalNum: 0
}


// WEBPACK FOOTER //
// ./src/store/cart/state.js